export default __webpack_public_path__ + "amazon-logo.3af14b2c.png";